import { ReactNode, useMemo } from 'react';
import TagIds from '~/constants/common/tagIds';
import useGetConsumerHref from '~/hooks/common/selectors/useGetConsumerHref';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export type SuggestedSearch = {
  Icon?: ReactNode;
  title: string;
  link: string;
};

function SuggestedImage({
  width = 48,
  vehicle
}: {
  width?: number;
  vehicle: string;
}) {
  return (
    <img
      alt=""
      src={`${process.env.CVNA_APP_CDN_URL}/home-assets/nba/${vehicle}.png?width=${width}`}
      height={24}
      width={width}
    />
  );
}

export default function useGetSuggestedSearches(): SuggestedSearch[] {
  const getHref = useGetConsumerHref();

  return useMemo(
    () => [
      {
        title: 'Shop Great Deals',
        link: getHref(
          generateSearchLinkFilter({
            filters: { tagIds: [TagIds.GreatDeals.toString()] }
          })
        )
      },
      {
        title: 'Price Drops',
        link: getHref(
          generateSearchLinkFilter({
            filters: { tagIds: [TagIds.PriceDrop.toString()] }
          })
        )
      },
      {
        title: 'Free Shipping',
        link: getHref(
          generateSearchLinkFilter({
            filters: { isFreeDelivery: true }
          })
        )
      },
      {
        Icon: <SuggestedImage vehicle="electric" />,
        title: 'Electric',
        link: getHref('/cars/electric')
      },
      {
        Icon: <SuggestedImage vehicle="hybrid" />,
        title: 'Hybrids',
        link: getHref('/cars/hybrid')
      },
      {
        Icon: <SuggestedImage vehicle="suv" />,
        title: 'SUVs',
        link: getHref('/cars/suv')
      },
      {
        Icon: <SuggestedImage vehicle="sedan" />,
        title: 'Sedans',
        link: getHref('/cars/sedan')
      },
      {
        Icon: <SuggestedImage width={45} vehicle="truck" />,
        title: 'Trucks',
        link: getHref('/cars/truck')
      },
      {
        Icon: <SuggestedImage width={45} vehicle="plug-in-hybrid" />,
        title: 'Plug-in Hybrids',
        link: getHref('/cars/plugin-hybrid')
      },
      {
        title: 'Cars Under $20,000',
        link: getHref(
          generateSearchLinkFilter({ filters: { price: { max: 20000 } } })
        )
      },
      {
        title: 'Fuel Efficient',
        link: getHref(
          generateSearchLinkFilter({ filters: { mpg: { min: 30 } } })
        )
      }
    ],
    [getHref]
  );
}
